import React from 'react';
import {useGetMoversQuery} from '../../../../services/BBFinanceAPI';
import style from '../StockDashboard.module.css';
import '../../../../assets/css/spinner.css';
import Spinner from '../../../utils/Spinner';
import MostActive from './MostActive';
import Leaders from './Leaders';


const StockMovers = () => {
    const {data , isFetching} = useGetMoversQuery();
    const active = data?.active;
    const gainers = data?.leaders;
    const laggards = data?.laggards;
    const tableOfActive = active?.map((active, i) => ({
        key: i + 1,
        name: active.name,
        ticker: active.tickerName,
        prevclose: active.last,
        change: active.netChange,
        changepercentage: active.pctChange,
        volume: active.volume,
        dayhigh: active.dayHigh,
        daylow: active.dayLow,
    }));
    const tableOfGainers = gainers?.map((gainer, i) => ({
        key: i + 1,
        name: gainer.name,
        ticker: gainer.tickerName,
        prevclose: gainer.last,
        change: gainer.netChange,
        changepercentage: gainer.pctChange,
    }));

    const tableOfLosers = laggards?.map((laggard, i) => ({
        key: i + 1,
        name: laggard.name,
        ticker: laggard.tickerName,
        prevclose: laggard.last,
        change: laggard.netChange,
        changepercentage: laggard.pctChange,
    }))

    return (
        <>
            {
                  isFetching ? (
                        <Spinner />
                  ) : (
                        <>
                            <div className="mb-5">
                                <MostActive data={tableOfActive}/>
                            </div>
                            <div className="mb-5">
                                <Leaders data={tableOfGainers} type="leaders"/>
                            </div>
                            <div className="mb-5">
                                <Leaders data={tableOfLosers} type="laggards"/>
                            </div>
                        </>
                        
                  )
               }
        </>
    )
}

export default StockMovers
